<template>
  <div class="audience-list-table-for-multiple-play-date-event">
    <div class="file-download-buttons" v-if="isAssistantAdmissionPage == false"><a class="download-button csv" @click="showSendCSV">全参加者CSV</a><a class="download-button pdf" @click="showSendPDF">全参加者PDF</a></div>
    <div class="search-result-title">
      <div class="search-result-title-box search-result-title-play-dates" v-show="selected_play_dates.length > 0" v-for="(play_date, index) in selected_play_dates" :key="`play_date-${index}`">
        {{ play_date | formatDate }}
      </div>
      <div class="search-result-title-box search-result-title-ticket-type-name" v-show="selected_ticket_types.length > 0 && selected_ticket_types[0].hasOwnProperty('id')" v-for="(ticket, index) in selected_ticket_types" :key="`ticket-${index}`">
        {{ ticket.name }}
      </div>
      <div class="search-result-title-box search-result-title-ticket-type-name" v-if="selected_ticket_types.length == 0 || selected_ticket_types[0] == ''">すべてのチケット</div>
    </div>
    <div class="audience-count-box-and-admission-menu">
      <div class="audience-count-box">
        <span class="audience-count">{{ delimitThreeDigits(admittedAudienceCount) }}枚/{{ delimitThreeDigits(totalAudienceCount) }}枚</span>
      </div>
      <div class="admission-menu">
        <button class="qr-read-btn" @click="qrModalOpen">QR読取</button>
        <button class="assistant-btn" @click="assistantModalOpen">複数人で受付</button>
      </div>
    </div>
    <div class="actioncable-status-and-perpage-select-num-box-wrapper">
      <div class="actioncable-status">
        <actioncable-status></actioncable-status>
      </div>
      <div class="perpage-select-num-box">
        <div class="perpage-select-row">
          <p class="perpage-select-title">表示数：</p>
          <div class="select-disp-num">
            <label class="select-disp-label js-option-label" for="select-disp-label" @click="changeShowDispNum(true)"
              >{{ perPage }}件
              <div class="arrow-down"></div
            ></label>
            <ul class="select-disp-num-dropdown" v-if="is_show_disp_num == true">
              <li v-for="(number, index) in perPageSelects" :value="number" :key="index" :data-per-page="number" @click="setPerPage($event)">{{ number }}件</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="js-table" class="table">
        <thead id="js-head">
          <tr>
            <th class="admission-check">入場チェック</th>
            <th class="audience_list_label__no" id="audience_list_label__no">受付番号</th>
            <th class="audience_list_label__volume">枚数</th>
            <th class="audience_list_label__name">ニックネーム/メール</th>
            <template v-if="event_use_introducer">
            <template v-for="(eq, index) in event_questionnaires">
              <th class="audience_list_label__introducer_text" :key="eq.id">{{ eq.introducer_text }}</th>
            </template>
            </template>
            <th class="audience_list_label__play_dates">開催日</th>
            <th class="audience_list_label__ticket_types">チケット</th>
            <template v-if="use_introducer_tell">
              <th class="audience_list_label__introducer_tell">電話番号</th>
            </template>
            <template v-if="use_introducer_adress">
              <th class="audience_list_label__introducer_adress">住所</th>
            </template>
            <template v-if="use_introducer_name">
              <th class="audience_list_label__introducer_name">氏名</th>
            </template>
            <th class="audience_list_label__first_admission_date">初回もぎり日時</th>
            <th class="audience_list_label__note">備考</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(audience, index) in items" :key="index">
            <td v-if="audience.admission == true" class="admission-check admission-check-true">
              <button class="admission-true" @click="unaccept_admission(audience.admission_url, audience.volume)">入場解除</button>
            </td>
            <td v-else class="admission-check admission-check-false">
              <button class="admission-false" @click="accept_admission(audience.admission_url, audience.volume)">もぎる</button>
            </td>
            <td class="audience_list_label__no">
              <span class="audience_no">{{ audience.receipt_no }}</span>
              <template v-if="audience.admission == true">
                <span class="admitted">入場済み</span>
              </template>
              <p v-if="audience.is_divide_ticket" class="divide_annotation">分配受取</p>
              <p v-if="audience.is_divide_percial" class="divide_annotation">一部分配</p>
            </td>
            <td class="audience_list_label__volume">
              <span class="audience_volume">{{ audience.volume }}</span>
            </td>
            <td class="audience_list_label__name">
              <span class="audience-name">{{ audience.name }}</span>
              <span class="audience-email">{{ audience.email }}</span>
            </td>
            <template v-if="event_use_introducer">
              <template v-for="(eq, index) in event_questionnaires">
                <td v-if="audience.event_questionnaire_answers.length > index" class="audience_list_label__introducer_text" :key="index">
                  {{ audience.event_questionnaire_answers[index].introducer }}
                </td>
                <td v-else class="audience_list_label__introducer_text" :key="index">
                  未回答
                </td>
              </template>
            </template>
            <td class="audience_list_label__play_dates">
              <template v-if="audience.is_albirex_event != true">
                <span v-for="(play_date, index) in audience.play_dates" :key="index">
                  <span class="audience_play_date">{{ play_date }}</span>
                </span>
              </template>
              <template v-else>
                <span class="audience_play_date">{{ audience.albirex_event_play_dates }}</span>
              </template>
            </td>
            <td class="audience_list_label__ticket_types">
              {{ audience.ticket_type_name }}
            </td>
            <template v-if="use_introducer_tell">
              <td class="audience_list_label__introducer_tell">
                {{ audience.introducer_tell }}
              </td>
            </template>
            <template v-if="use_introducer_adress">
              <td class="audience_list_label__introducer_adress">
                {{ audience.introducer_adress }}
              </td>
            </template>
            <template v-if="use_introducer_name">
              <td class="audience_list_label__introducer_name">
                {{ audience.introducer_name }}
              </td>
            </template>
            <td class="audience_list_label__first_admission_date">
              <span class="audience-first-admission-date">{{ audience.last_admission_at }}</span>
            </td>
            <td class="audience_list_label__note">{{ audience.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="paginete-for-audience-list">
      <paginate ref="paginator" :page-count="getPaginateCount" :prev-text="'前へ'" :next-text="'次へ'" :click-handler="paginateClickCallback" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
    </div>
    <div class="confirm-modal-for-file">
      <confirm-modal-for-file :eventer_mail="eventer_mail" :main_event_title="main_event_title" :file_format="file_format" :send_file_api_path="send_file_api_path" v-if="showConfirmModalForFile == true" @close-btn-click="closeConfirmModalForFile" @offShowConfirmModalForFile="offShowConfirmModalForFile"></confirm-modal-for-file>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    get_audiences_path: { type: String, required: true },
    event_use_introducer: { type: Boolean, required: true },
    event_introducer_text: { type: String, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    send_csv_path: { type: String, required: true },
    send_pdf_path: { type: String, required: true },
    main_event_title: { type: String, required: true },
    main_event_id: { type: Number, required: true },
    eventer_mail: { type: String },
    admission_accept_path: { type: String, required: true },
    admission_unaccept_path: { type: String, required: true },
    can_action_cable: { type: Boolean, required: true },
    is_assistant_page: { type: Boolean, required: true, default: false }
  },
  data() {
    return {
      perPageSelects: [100, 500, 1000],
      is_show_disp_num: false,
      showConfirmModalForFile: false,
      showLoading: false,
      file_format: '',
      send_file_api_path: '',
      isAssistantAdmissionPage: false,
    };
  },
  created() {
    this.getAudiences();
  },
  mounted() {
    const _this = this;
    $(window).on('click', function (e) {
      _this.changeShowDispNum(false);
    });
    // 処理の重複防止
    $('.js-option-label').on('click', function (e) {
      e.stopPropagation();
    });
  },
  computed: {
    audiences: function () {
      return this.$store.getters['audience/getAudiencesFromEvent'];
    },
    items: function () {
      return this.audiences;
    },
    getPaginateCount: function () {
      if (this.perPage === 0) {
        return 1;
      } else {
        return Math.ceil(this.totalAudienceCount / this.perPage);
      }
    },
    selected_play_dates: function () {
      return this.$store.getters['audience/getPlayDates'];
    },
    selected_ticket_types: function () {
      return this.$store.getters['audience/getTicketTypes'];
    },
    currentPage: function () {
      return this.$store.getters['audience/getCurrentPage'];
    },
    perPage: function () {
      return this.$store.getters['audience/getPerPage'];
    },
    totalAudienceCount: function () {
      return this.$store.getters['audience/getTotalAudienceCount'];
    },
    admittedAudienceCount: function () {
      return this.$store.getters['audience/getAdmittedAudienceCount'];
    },
  },
  methods: {
    async getAudiences() {
      const isAdmissionPage = true;
      this.setIsAssistantAdmissionPage();
      this.showLoading = true;
      await this.$store.dispatch('audience/getAudiences', { api_path: this.get_audiences_path, t: '', isAdmissionPage, is_assistant_admission_page: this.isAssistantAdmissionPage }).catch((error) => {
        alert('エラーが発生しました。時間をおいてから改めてお試しください。');
      });
      this.$emit('close-loading');
    },
    paginateClickCallback: function (pageNum) {
      this.setCurrentPage(Number(pageNum));
    },
    changeShowDispNum: function (is_show) {
      this.is_show_disp_num = is_show;
    },
    setPerPage: function (event) {
      const perPage = event.target.dataset.perPage === 0 ? 0 : parseInt(event.target.dataset.perPage);
      this.$store.commit('audience/setPerPage', perPage);
      // 1ページ目の場合はaudiencesを取得
      // それ以外の場合はcurrentPageを書き換える(書き換え先でaudiencesを取得)
      if (this.currentPage == 1) {
        this.getAudiences();
      } else {
        this.setCurrentPage(1);
      }
    },
    setCurrentPage: function (pageNum) {
      this.$store.commit('audience/setCurrentPage', pageNum);
      this.getAudiences();
    },
    // デリミタ処理
    delimitThreeDigits(data) {
      const target = String(data);
      return target.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    showSendCSV() {
      this.file_format = 'CSV';
      this.showConfirmModalForFile = true;
      this.hideBackground();
      this.send_file_api_path = this.send_csv_path;
    },
    showSendPDF() {
      this.file_format = 'PDF';
      this.showConfirmModalForFile = true;
      this.hideBackground();
      this.send_file_api_path = this.send_pdf_path;
    },
    closeConfirmModalForFile() {
      this.showConfirmModalForFile = false;
      this.showBackground();
    },
    openLoading() {
      this.showLoading = true;
    },
    closeLoading() {
      this.showLoading = false;
    },
    hideBackground() {
      document.body.style.overflow = 'hidden';
    },
    showBackground() {
      document.body.style.overflow = '';
    },
    // 子コンポネートからフラグを変更するためのメソッド
    offShowConfirmModalForFile() {
      this.showConfirmModalForFile = false;
    },
    // もぎり
    accept_admission(admission_url, volume) {
      this.$store.dispatch('audience/accept_admission', { program_id: null, event_id: this.main_event_id, admission_url: admission_url, api_path: this.admission_accept_path, can_action_cable: this.can_action_cable, countup: volume });
    },
    // もぎり解除
    unaccept_admission(admission_url, volume) {
      let assistantId = location.pathname.split('/audience_list_admission/')[1];
      this.$store.dispatch('audience/unaccept_admission', { program_id: null, event_id: this.main_event_id, admission_url: admission_url, api_path: this.admission_unaccept_path, can_action_cable: this.can_action_cable, countdown: volume, assistant_id: assistantId });
    },
    // VueコンポーネントからQRモーダルを開くためのカスタムイベント
    qrModalOpen() {
      const event = new CustomEvent('qr-read-button-click', { detail: { totalAudienceCount: this.totalAudienceCount, admittedAudienceCount: this.admittedAudienceCount } });
      window.dispatchEvent(event);
    },
    assistantModalOpen() {
      const event = new Event('assistant-button-click', { detail: { totalAudienceCount: this.totalAudienceCount, admittedAudienceCount: this.admittedAudienceCount } });
      window.dispatchEvent(event);
    },
    setIsAssistantAdmissionPage() {
      const currentPath = window.location.pathname;
      if (currentPath.endsWith('audience_list_admission')) {
        this.isAssistantAdmissionPage = false;
      } else {
        this.isAssistantAdmissionPage = true;
      }
    },
  },
  watch: {
    currentPage: function (newVal) {
      if (newVal == 1) this.$refs.paginator.selectFirstPage();
    },
  },
  filters: {
    formatDate(dateStr) {
      const year = dateStr.slice(0, 4);
      const month = parseInt(dateStr.slice(4, 6), 10);
      const day = parseInt(dateStr.slice(6), 10);
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.audience-list-table-for-multiple-play-date-event {
  width: 100%;
  line-height: 1em;
  margin-top: 15px;
  position: relative;

  @media screen and (max-width: 1140px) {
    max-width: 100%;
  }

  @media screen and (max-width: $break-point) {
    max-width: 100%;
  }

  .file-download-buttons {
    margin-bottom: 31px;
    text-align: right;

    @media screen and (max-width: 1140px) {
      justify-content: right;
      margin-right: 30px;
    }

    @media screen and (max-width: $break-point) {
      justify-content: right;
      margin-right: 20px;
      margin-bottom: 20px;
    }

    a {
      color: $shop-blue;
      cursor: pointer;
      font-size: 15px;

      @media screen and (max-width: $break-point) {
        font-size: 13px;
      }
    }

    .csv {
      margin-right: 10px;
    }
  }

  .audience-count-box-and-admission-menu {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    height: 15px;

    @media screen and (max-width: 1140px) {
      margin-right: 20px;
    }
  }

  .search-result-title {
    display: flex;
    flex-wrap: wrap;
    row-gap: 5px;
    color: $shop-navy;
    font-size: 18px;
    font-weight: 600;
    width: calc(100% - 215px);

    @media screen and (max-width: 1140px) {
      margin-left: 20px;
    }

    @media screen and (max-width: $break-point) {
      margin-left: 20px;
      font-weight: 600;
      font-size: 15px;
      width: unset;
    }

    .search-result {
      padding: 0 5px;
    }
  }

  .search-result-title-box {
    line-height: 1;
    white-space: nowrap;
    margin-right: 5px;
    padding-right: 5px;
    border-right: 1px solid $shop-lightgray;

    &:last-child {
      margin-right: 0;
      padding-right: 0;
      border-right: none;
    }
  }

  .admission-menu {
    position: absolute;
    top: 45px;
    right: 0;

    @media screen and (max-width: 1140px) {
      right: 30px;
    }

    @media screen and (max-width: $break-point) {
      position: unset;
      top: unset;
      right: unset;
    }

    .qr-read-btn {
      width: 66px;
      height: 30px;
      background-color: #fff;
      border: 1px solid $shop-lightgray;
      border-radius: 4px;
      font-size: 13px;
      color: $shop-navy;
      font-weight: 600;

      @media screen and (max-width: $break-point) {
        width: 75px;
      }
    }

    .assistant-btn {
      width: 98px;
      height: 30px;
      background-color: #fff;
      border: 1px solid $shop-lightgray;
      border-radius: 4px;
      font-size: 13px;
      color: $shop-navy;
      font-weight: 600;

      @media screen and (max-width: $break-point) {
        width: 110px;
      }
    }
  }

  .audience-count-box {
    @media screen and (max-width: 1140px) {
      margin-left: 20px;
    }

    @media screen and (max-width: $break-point) {
      justify-content: space-between;
      margin-left: 20px;
    }

    .audience-count {
      font-size: 18px;
      font-weight: 600;
      min-width: 10px;
    }
  }

  .actioncable-status-and-perpage-select-num-box-wrapper {
    display: flex;
    align-items: end;
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .actioncable-status {
    white-space: nowrap;
  }

  .perpage-select-num-box {
    display: inline-flex;
    justify-content: end;
    text-align: right;
    width: 100%;
    height: 20px;

    @media screen and (max-width: $break-point) {
      margin-top: 36px;
    }

    .perpage-select-row {
      display: inline-flex;
      align-items: flex-end;
      font-size: 13px;

      @media screen and (max-width: 1140px) {
        justify-content: right;
        margin-right: 20px;
      }

      @media screen and (max-width: $break-point) {
        justify-content: right;
        margin-right: 20px;
      }

      .perpage-select-title {
        color: #000;
      }
      .perpage-select-form {
        height: auto;
        border: none;
        padding: 0;
        color: $shop-navy;
        font-size: 14px;
      }
    }

    .select-disp-num {
      display: inline-flex;
      align-items: flex-end;

      label {
        margin: 0;
        gap: 4px;
        cursor: pointer;
      }

      ul li {
        color: $shop-navy;
      }
    }
  }

  .table-responsive {
    border-left: none;
    border-right: none;
    border-bottom: none;

    @media screen and (max-width: $break-point) {
      margin-bottom: 0;
      border-top: 1px solid $event_main-hr-gray;
    }
  }

  tbody > tr > td .audience-email,
  tbody > tr > td .audience-name {
    white-space: nowrap;
  }

  .audience-email {
    overflow: hidden;
    word-break: break-all;
    font-size: 12px;
    max-width: 400px;
  }

  .audience_list_label__name span {
    display: block;
  }

  .audience_list_label__play_dates span {
    display: block;
  }

  .table > thead > tr {
    background-color: $shop-input-gray;

    .audience_list_label__note {
      min-width: 200px;
    }

    .admission-check {
      position: sticky;
      left: 0;
      background-color: $shop-input-gray;
    }
  }

  // bootstrapのデフォルトスタイル打ち消し
  .table > thead > tr > th {
    border-bottom: none;
    border-top: 1px solid $event_main-hr-gray;

    @media screen and (max-width: 991px) {
      border-top: none;
      padding: 10px 40px 12px 9px;
    }
  }

  .table > tbody > tr > td {
    border-top: none;
    font-size: 15px;
    padding: 15px 32px 17px 8px;

    @media screen and (max-width: 991px) {
      padding: 10px 40px 12px 9px;
    }
  }

  .table > tbody > tr > td:last-child {
    padding: 15px 0 17px 8px;
  }

  .table > tbody > tr {
    border-top: 1px solid $event_main-hr-gray;

    .admission-check {
      position: sticky;
      left: 0;
      background-color: #fff;
    }

    .audience_list_label__no {
      .admitted {
        font-size: 12px;
        display: block;
      }

      .divide_annotation {
        font-size: 12px;
        color: $gray;
      }
    }

    .admission-check-false {
      button {
        width: 80px;
        height: 34px;
        background-color: #fff;
        color: $shop-blue;
        border: 1px solid $shop-blue;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 200;
      }
    }

    .admission-check-true {
      button {
        width: 80px;
        height: 34px;
        background-color: $shop-navy;
        color: #fff;
        border: 1px solid $shop-navy;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 200;
      }
    }

    .audience-first-admission-date {
      color: $gray;
      font-size: 12px;
      display: inline-block;
      width: 100px;
      white-space: normal;
    }
  }

  .table > tbody > tr:last-child {
    border-bottom: 1px solid $event_main-hr-gray;
  }

  .table {
    max-width: 100%;
  }

  th {
    width: 0;
    height: 12px;
    white-space: nowrap;
    text-align: left;
    color: $gray;
    opacity: 1;
    font-weight: 600;
    font-size: 12px;
    padding-top: 12px;
    padding-bottom: 14px;

    @media screen and (max-width: $break-point) {
      padding: 6px 40px 9px 0;
      font-weight: 700;
    }
  }

  .receipt-no-label {
    color: $shop-navy;
    display: flex;
    align-items: center;

    .arrow-down {
      content: '';
      width: 7px;
      height: 7px;
      border-top: 1px solid $shop-navy;
      border-left: 1px solid $shop-navy;
      transform: translateY(-50%) rotate(-135deg);
      pointer-events: none;
      margin-left: 5px;
      margin-top: 5px;
    }
  }

  td {
    width: 0;
    height: 46px;
    white-space: nowrap;
  }

  tbody > tr > td {
    vertical-align: middle;
    height: 15px;
    text-align: left;
    color: #000;
  }

  .select-disp-num {
    position: relative;
    height: 25px;
    align-items: center;

    .select-disp-label {
      display: flex;
      align-items: center;
      color: $shop-navy;
    }

    ul {
      display: block;
      text-align: left;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0 0 10px $shadow-black;
      list-style: none;
      position: absolute;
      width: 180px;
      border-radius: 6px;
      top: 18px;
      right: 4px;

      a,
      li {
        padding-left: 10px;
        line-height: 35px;
        color: $shop-gray;
        font-size: 15px;
        opacity: 1;

        &:hover {
          background-color: $shop-page-title-gray;
        }
      }
    }

    .arrow-down {
      content: '';
      width: 7px;
      height: 7px;
      border-top: 1px solid $allow-down-gray;
      border-left: 1px solid $allow-down-gray;
      transform: translateY(-50%) rotate(-135deg);
      pointer-events: none;
      margin-left: 5px;
      margin-top: 5px;
    }
  }

  .paginete-for-audience-list {
    text-align: center;

    .pagination {
      margin: 30px;
    }

    ul.pagination {
      background: #fff;

      & ::v-deep li > a {
        color: #000;
        border: 1px solid $shop-lightgray;
        border-radius: 4px;
        margin-right: 5px;
        font-size: 13px;
      }

      & ::v-deep .active > a {
        color: #fff;
        background: $gray;
      }
    }
  }
}
</style>
